import { createAction } from '@reduxjs/toolkit'

import { Dashboard, Organization } from 'types'

const NAMESPACE = 'DASHBOARD_PRINT_PAGE'

// fetch dashboard
export const fetchDashboardSuccess = createAction<Dashboard>(
    `${NAMESPACE}/FETCH_DASHBOARD_SUCCESS`
)

// fetch organization
export const fetchOrganizationSuccess = createAction<Organization>(
    `${NAMESPACE}/FETCH_ORGANIZATION_SUCCESS`
)
